import React from "react";
import Layout from "../Layout/Layout";

const Bors = () => {
  return <Layout></Layout>;
};

export default Bors;
